import type { StartPayConfig } from "../types/config";
import type { PaymentSession, StartPaymentInput } from "../types/payment";
import { buildUrl } from "../utils/buildUrl";
import { requestJson } from "../utils/request";
import { DEFAULT_ENDPOINTS } from "./constants";

export const createPaymentSession = (config: StartPayConfig, input: StartPaymentInput, signal?: AbortSignal) => {
  const endpoint = config.endpoints?.createSession ?? DEFAULT_ENDPOINTS.createSession;

  // The backend endpoint must create the order/session with secret gateway credentials.
  return requestJson<PaymentSession>(buildUrl(config.apiBaseUrl, endpoint), {
    body: {
      ...input,
      publicKey: config.publicKey,
      environment: config.environment
    },
    headers: config.headers,
    timeout: input.timeout ?? config.timeout,
    signal
  });
};
